export const Select = ({ label, options, onChange, required, error, placeholder }) => {
  return (
    <section className="select-main">
      <label className="select-label" htmlFor={label}>
        {label}
        <span>{required ? "Required" : ""}</span>
      </label>
      <select
        name={label}
        id={label}
        onChange={e => onChange(e.target.value)}
        className="select-proper"
      >
        <option value="">{placeholder}</option>
        {options.map(option => (
          <option key={option.abbreviation} value={option.abbreviation}>
            {option.name}
          </option>
        ))}
      </select>
      <p className="select-error">{error}</p>
    </section>
  );
};
